// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3PbyB","col":"styles_col__2BJ4k"};